export default "/images/fidelidade-since-logo.png?377d142a0179dc5ff2b26d6f99a2bd6e";